import { useState } from 'react';
import { ButtonText } from '@morressier/alembic';
import { Box, Text } from '@chakra-ui/react';
import { FormFieldAbstract } from '@publishing-engine/domain/types/article';
import { useFormContext } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FieldLabel } from 'src/components/Field';
import RichTextPreview from 'src/components/Submission/GenericFieldComponents/RichText/RichTextPreview';
import RichTextSubmission from 'src/components/Submission/GenericFieldComponents/RichText/RichTextSubmission';

export default function Abstract({
  config,
  isMetadataExtracted,
  editAbstract
}: {
  config: FormFieldAbstract;
  isMetadataExtracted: boolean;
  editAbstract: string;
}) {
  const form = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const { getValues } = form;
  const {
    metadata: { abstract }
  } = getValues();

  const [isEditing, setIsEditing] = useState<boolean>(!abstract);

  const renderReadView = () => (
    <Flex flexDirection="column" gap={4}>
      <Text textStyle="headingItem">Abstract</Text>
      <Box textStyle="textBody">
        <RichTextPreview value={abstract} />
      </Box>

      <ButtonText
        width="fit-content"
        variant="primary"
        onClick={() => setIsEditing(true)}
      >
        {editAbstract ?? 'Edit Extracted Abstract'}
      </ButtonText>
    </Flex>
  );

  const renderEditView = () => (
    <Flex flexDirection="column" gap={4}>
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
        helpText={labels.helpText}
      />

      <RichTextSubmission
        initialValue={abstract}
        label={labels.main}
        field={field}
        maxWords={validations?.maxWords}
      />
    </Flex>
  );

  return isMetadataExtracted && !isEditing
    ? renderReadView()
    : renderEditView();
}
